export enum ReportCategory {
  TCFD = "TCFD",
  SDR = "SDR",
  SFDR = "SFDR",
  TNFD = "TNFD",
  DLUHC = "DLUHC",
  DWP_Climate_Disclosures = "DWP Climate Disclosures",
  DWP_Nature_Disclosures = "DWP Nature Disclosures",
  STEWARDSHIP = "STEWARDSHIP",
  STEWARDSHIP_CODE = "STEWARDSHIP_CODE",
  ENGAGEMENT = "ENGAGEMENT",
}
